/**
 * Adds i month of given day
 */
export default function addMonths(dt, i) {
  const date = new Date(dt);
  return new Date(date.setMonth(date.getMonth() + i));
}
